import Vue from "vue";
import Vuelidate from 'vuelidate';

import Nss from './components/index';

Vue.component("BackLink", Nss.Misc.BackLink);
Vue.component("Button", Nss.Misc.Button);
Vue.component("Checklist", Nss.Misc.Checklist);
Vue.component("Details", Nss.Misc.Details);
Vue.component("Panel", Nss.Misc.Panel);
Vue.component("PhaseBanner", Nss.Misc.PhaseBanner);
Vue.component("Rationale", Nss.Misc.Rationale);
Vue.component("WarningCallout", Nss.Misc.WarningCallout);
Vue.component("WarningCalloutAlt", Nss.Misc.WarningCalloutAlt);
Vue.component("InsetText", Nss.Misc.InsetText);
Vue.component("Wysiwyg", Nss.Misc.Wysiwyg);
Vue.component("Section", Nss.Misc.Section);
Vue.component("Form", Nss.Forms.Form);
Vue.component("DateOfBirth", Nss.Forms.DateOfBirth);
Vue.component("DateOfBirthInput", Nss.Forms.DateOfBirthInput);
Vue.component("IntroForm", Nss.Forms.IntroForm);
Vue.component("RadioList", Nss.Forms.RadioList);
Vue.component("Fieldset", Nss.Forms.Fieldset);
Vue.component("TextInput", Nss.Forms.TextInput);
Vue.component("Textarea", Nss.Forms.Textarea);
Vue.component("RadioButton", Nss.Forms.RadioButton);
Vue.component("CheckboxList", Nss.Forms.CheckboxList);
Vue.component("CheckboxButton", Nss.Forms.CheckboxButton);
Vue.component("Submit", Nss.Forms.Submit);
Vue.component("Errors", Nss.Forms.Errors);
Vue.component("Under16", Nss.Endpoints.Under16);
Vue.component("NoFTE16", Nss.Endpoints.NoFTE16);
Vue.component("UniversalCredit", Nss.Endpoints.UniversalCredit);
Vue.component("IncomeSupport", Nss.Endpoints.IncomeSupport);
Vue.component("CareHome", Nss.Endpoints.CareHome);
Vue.component("Pregnant", Nss.Endpoints.Pregnant);
Vue.component("WarPension", Nss.Endpoints.WarPension);
Vue.component("LowIncome", Nss.Endpoints.LowIncome);
Vue.component("HighlandsAndIslands", Nss.Endpoints.HighlandsAndIslands);
Vue.component("TaxCredits", Nss.Endpoints.TaxCredits);
Vue.component("ESA", Nss.Endpoints.ESA);
Vue.component("JSA", Nss.Endpoints.JSA);
Vue.component("PensionCredits", Nss.Endpoints.PensionCredits);
Vue.component("FTE19Pregnant", Nss.Endpoints.FTE19Pregnant);

Vue.use(Vuelidate);

export default {};